import React from 'react';
import { Instagram, Facebook, Youtube, Music2, ExternalLink } from 'lucide-react';
import { findSocialLinks } from '../lib/socialLinks';
import './SocialLinkCards.css';

/**
 * B-52.1 — link cards for Instagram / Facebook / X / TikTok / YouTube links
 * in a news post (rules in lib/socialLinks.js). Plain links, no embeds.
 *
 * Opened like the map and ticket links: target=_blank, which on the web is a
 * new tab and in the native app hands the URL to the OS (the platform's own
 * app if installed, else the browser).
 */

// lucide has no X or TikTok mark: X is a two-stroke inline SVG, TikTok gets a
// neutral music note.
const XMark = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2.2" strokeLinecap="round" aria-hidden="true">
    <path d="M4 4l16 16M20 4L4 20" />
  </svg>
);

const ICONS = { instagram: Instagram, facebook: Facebook, youtube: Youtube, tiktok: Music2, x: XMark };

export default function SocialLinkCards({ body }) {
  const links = findSocialLinks(body);
  if (!links.length) return null;
  return (
    <div className="social-link-cards">
      {links.map(link => {
        const Icon = ICONS[link.platform] || ExternalLink;
        return (
          <a
            key={link.href}
            className="social-link-card"
            href={link.href}
            target="_blank"
            rel="noopener noreferrer nofollow"
            onClick={e => e.stopPropagation()}
          >
            <span className={`social-link-icon social-${link.platform}`}><Icon size={18} /></span>
            <span className="social-link-text">
              <span className="social-link-label">{link.label}</span>
              <span className="social-link-host">{link.host}</span>
            </span>
            <ExternalLink size={14} className="social-link-out" aria-hidden="true" />
          </a>
        );
      })}
    </div>
  );
}
